import styled from "styled-components";

interface Props {
    width?: string;
}

const GroupColumn = styled.div<Props>`
    display: grid;
    grid-template-columns: auto 1fr auto auto auto;
    align-items: center;
    margin-bottom: 10px;
    column-gap: 10px;
    width: ${(props) => props.width || '100%'};

    label {
        font-size: 1.15em;
        color: var(--blue_main);
    }
`;


export default GroupColumn;